// https://material-ui.com/pt/customization/default-theme/

import { ThemeProvider } from "styled-components";

const theme = {
  palette: {
    primary: "#1A5DC9",
    secondary: "#d6e5ff",
    tertiary: "#012C67",
    black: "#2b2b2b",
    white: "white",
    orange: "#fc9d03",
    grey: "#858585",
    lightgrey: "#DDDDDD",
    darkgrey: "#E8E1D9",
    green: "#7FC8A9",
    lightgreen: "#bcdccf",
    darkgreen: "#39A388",
    red: "#FA8072",
    darkred: "#F55C47",
    blue: "#5C7AEA",
    darkblue: "#0F52BA",
    transparent: "transparent",
    gold: "#FFD700",
    lightblue: "#1C4590",
    purple: "#a790f5",
    headercolor: "#FAFAFA",
  },
  fonts: {
    mulish: "Mulish",
    comfortaa: "Comfortaa",
    montserrat: "Montserrat",
    helvetica: "Helvetica",
    mohave: "Mohave",
    opensans: "Open Sans",
    roboto: "Roboto",
  },
  spacing: (multiplier) => 8 * multiplier + "px",
};

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
